/**
 * Created by bas.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    Emitter        = require('cjs-emitter'),
    tools          = {
        ids: {
            base: 'network',
            test: 'traceroute'
        },
        addZero: function ( time ) {
            return (time < 10 ? '0' + time : time);
        }
    },
    test, gettext;


/**
 * Update manager. Listening daemon for records changes and emitting corresponding events to application.
 * Can emit events: progress, state, add, remove.
 *
 * @constructor
 * @extends Emitter
 */
function Test () {
    Emitter.call(this);
    /**
     * Stop this client and remove all it listeners. Use it for cleanup before application exit.
     */
    this.destroy = function () { this.events = {}; };
}

Test.prototype = Object.create(Emitter.prototype);
Test.prototype.constructor = Test;


function sendStatistic ( data ) {
    var envs;

    // statistic needs only for stalker
    if ( !window.core.backend ) {

        return;
    }
    envs = gSTB.GetEnv(JSON.stringify({
        varList: [
            'language',
            'igmp_conf',
            'upnp_conf',
            'mc_proxy_enabled',
            'mc_proxy_url',
            'input_buffer_size',
            'timezone_conf',
            'audio_initial_volume',
            'audio_dyn_range_comp',
            'audio_operational_mode',
            'audio_stereo_out_mode',
            'audio_spdif_mode',
            'audio_hdmi_audio_mode',
            'lan_noip',
            'ipaddr_conf',
            'dnsip',
            'pppoe_enabled',
            'pppoe_login',
            'pppoe_dns1',
            'wifi_ssid',
            'wifi_int_ip',
            'portal1',
            'portal2',
            'portal_dhcp',
            'use_portal_dhcp',
            'bootstrap_url',
            'update_url',
            'update_channel_url',
            'ntpurl',
            'mcip_img_conf',
            'mcport_img_conf',
            'netmask',
            'tvsystem',
            'graphicres',
            'auto_framerate',
            'force_dvi',
            'gatewayip',
            'pppoe_pwd',
            'wifi_int_dns',
            'wifi_auth',
            'wifi_enc',
            'wifi_psk',
            'wifi_wep_key1',
            'wifi_int_mask',
            'wifi_int_gw',
            'wifi_wep_def_key',
            'wifi_wep_key2',
            'wifi_wep_key3',
            'wifi_wep_key4',
            'ethinit',
            'partition',
            'kernel',
            'Ver_Forced',
            'componentout',
            'bootupgrade',
            'do_factory_reset',
            'serial#',
            'Boot_Version',
            'timezone_conf_int',
            'showlogo',
            'logo_x',
            'logo_y',
            'bg_color',
            'fg_color',
            'video_clock',
            'front_panel',
            'ts_endType',
            'Image_Date',
            'Image_Version',
            'Image_Desc',
            'ts_on',
            'lang_audiotracks',
            'autoupdate_cond',
            'settMaster',
            'stdin',
            'stdout',
            'stderr',
            'bootcmd',
            'ethaddr',
            'betaupdate_cond',
            'lang_subtitles',
            'subtitles_on',
            'ssaverDelay',
            'autoupdateURL'
        ]
    }));

    if ( data ) {
        try {
            envs = JSON.parse(envs);
            envs.result.traceroute = data;
            envs = JSON.stringify(envs);
        } catch ( error ) {
            console.log(error);
            envs = JSON.stringify({errCode: 0, errMsg: '', result: data});
        }
    }

    //console.log('send this:' + 'body=' + envs);
    window.core.backend.request('/network-diagnostic', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'PUT',
        onload: function ( error, loadedData ) {
            console.log('result stalker answer data: ' + JSON.stringify(loadedData));
            console.log('result stalker error data: ' + JSON.stringify(error));
        },
        body: 'body=' + envs
    });
    //    } else {
    //        // statistic for portal for aura models
    //        request = new XMLHttpRequest();
    //        request.open('PUT', 'http://freetvstat.iptv.infomir.com.ua/api/env/' + gSTB.GetDeviceMacAddress(), true);
    //        request.setRequestHeader('Content-Type', 'application/json');
    //        request.onreadystatechange = function () {
    //            if ( request.readyState === 4 ) {
    //                if ( request.status === 200 ) {
    //                    console.log(request.responseText, 'success stat sending');
    //                } else if ( request.status === 0 || request.status === 404 ) {
    //                    console.log('Sending vars error');
    //                }
    //            }
    //        };
    //        request.send(envs);
    //    }
}


/**
 * Start test.
 *
 * @param {Object} config config
 * @param {Object} config.options config
 * @param {Object} config.options.time custom test duration
 * @param {Object} config.options.domains custom test domains
 */
Test.prototype.start = function ( config ) {
    var activeDownloads = [],
        duration        = config && config.options && config.options.time ? config.options.time : 120,
        startTime       = new Date(),
        endTime         = new Date(),
        allDownloads    = JSON.parse(stbDownloadManager.GetQueueInfo()),
        self            = this,
        ind, domains;

    if ( config && config.options && config.options.domains ) {
        domains = config.options.domains;
    } else {
        domains = ['echo-01.infomir.com', 'echo-03.infomir.com'];
    }

    if ( window.MODE_STALKER ) {
        // stalker mode
        domains = window.core.backend.settings.mtr_hostnames || [];
        duration = window.core.backend.settings.mtr_report_cycles || 60;
    }

    // strange calculation for finish time
    endTime.setSeconds(startTime.getSeconds() + (duration * domains.length) + 60);
    // save all active jobs, because mtr can ruin downloads
    for ( ind = 0; ind < allDownloads.length; ind++ ) {
        if ( allDownloads[ind].state === 1 || allDownloads[ind].state === 2 ) {
            activeDownloads.push(allDownloads[ind]);
            stbDownloadManager.StopJob(allDownloads[ind].id);
        }
    }

    this.emit('render', [
        {
            items: [gettext('Perform diagnostics') + '...']
        }, {
            items: [
                gettext('Start') + ': ' + startTime.getHours() + ':' +
                tools.addZero(startTime.getMinutes()) + ':' + tools.addZero(startTime.getSeconds())
            ]
        }, {
            items: [
                gettext('Estimated time of completion') + ': ' + endTime.getHours() + ':' +
                tools.addZero(endTime.getMinutes()) + ':' + tools.addZero(endTime.getSeconds())
            ]
        }
    ]);
    // hack to run mtr before browser render all page
    setTimeout(function () {
        var count   = domains.length,
            data    = [{items: [gettext('IP Address'), gettext('Loss'), gettext('Ping')]}],
            results = '',
            result  = '',
            index, text;

        //console.log('start measure for ' + JSON.stringify(domains));
        for ( index = 0; index < count; index++ ) {
            result = gSTB.RDir('mtr --report --no-dns --report-cycles ' + duration + ' ' + domains[index]);
            results += 'Traceroute to domain: ' + domains[index] + '\n' + result + '\n';
        }
        result = result.split('\n');
        result.shift();
        result.shift();
        result.pop();
        result.forEach(function ( item ) {
            text = item.trim().replace(/\s{2,}/g, ' ').split(' ');
            data.push({items: [text[1], text[2], '' + Math.round(text[5])]});
        });
        self.emit('render', data);
        // restore active downloads
        for ( index = 0; index < activeDownloads.length; index++ ) {
            stbDownloadManager.StartJob(activeDownloads[index].id);
        }
        sendStatistic(results);
    }, 0);
};


function buildSettingsItem ( config ) {
    test = new Test();

    return {
        id: 'networkDiagnostics',
        name: gettext('Network diagnostics'),
        parent: tools.ids.base,
        type: 'option',
        description: gettext('Get info about network state'),
        icon: 'theme-icon-settings',
        title: 'network diagnostics',
        config: {focusable: false},
        // You can not interrupt the test before it is completed
        // Вы не сможете прервать тест до его завершения
        // Ви не зможете перервати тест до його завершення
        warningText: gettext('Attention') + ': ' + gettext('Estimated time to complete the test - 10 minutes.'),
        events: {
            click: function () {
                var self = this;

                self.$node.classList.add('padded');
                test.events['render'] = undefined;
                test.addListener('render', function ( data ) {
                    self.init({data: data, size: data.length > 5 ? 5 : data.length});
                });
                test.start(config);
            }
        },
        prepareForRender: function ( data, callback ) {
            callback([{items: [gettext('Perform diagnostics')]}]);
        },
        render: config.api.renders.popupLayoutList,
        data: {}
    };
}


module.exports = {
    onInit: function ( config, callback ) {
        callback();
    },
    onAppInit: function ( config, callback ) {
        callback(null, {});
    },
    onSettingsInit: function ( config, callback ) {
        // lang load
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            callback(null, {content: [buildSettingsItem(config)]});
        });
    }
};
